var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-layout",
    {
      attrs: {
        wrap: "",
        row: "",
        "justify-space-between": "",
        "align-space-around": "",
      },
    },
    [
      _vm.mandatoryMetadataFields.length > 0
        ? _c("v-flex", { attrs: { xs12: "", "pb-2": "" } }, [
            _c("span", [_vm._v("Mandatory Fields")]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm._l(_vm.mandatoryMetadataFields, function (field) {
        return _c(
          "v-flex",
          { key: field.Key, attrs: { xs12: "" } },
          [
            _c(
              "v-layout",
              { attrs: { row: "", wrap: "" } },
              [
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm3: "", "pl-2": "", "pr-2": "" } },
                  [
                    _c("v-text-field", {
                      attrs: {
                        box: "",
                        label: "Field Name",
                        rules: _vm.fieldNameRule,
                        readonly: "",
                      },
                      model: {
                        value: field.Field,
                        callback: function ($$v) {
                          _vm.$set(field, "Field", $$v)
                        },
                        expression: "field.Field",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-flex",
                  { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                  [
                    _c("v-select", {
                      attrs: {
                        box: "",
                        label: "Field Type",
                        items: _vm.fieldTypeNames,
                        rules: _vm.fieldTypeRule,
                        readonly: "",
                      },
                      model: {
                        value: field.FieldType,
                        callback: function ($$v) {
                          _vm.$set(field, "FieldType", $$v)
                        },
                        expression: "field.FieldType",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                field.Field == "ExecutionId"
                  ? _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("metadata-input-field", {
                          attrs: {
                            box: "",
                            "input-type": field.FieldType,
                            ignoreValidate: true,
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldValue,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldValue", $$v)
                            },
                            expression: "field.FieldValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("metadata-input-field", {
                          attrs: { box: "", "input-type": field.FieldType },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldValue,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldValue", $$v)
                            },
                            expression: "field.FieldValue",
                          },
                        }),
                      ],
                      1
                    ),
              ],
              1
            ),
          ],
          1
        )
      }),
      _vm._v(" "),
      _c("v-flex", { attrs: { xs12: "", "pb-2": "" } }, [
        _c("span", [_vm._v("Optional Fields")]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.additionalMetadataFields, function (field, i) {
        return _c(
          "v-flex",
          { key: field.Key, attrs: { xs12: "" } },
          [
            field.IsSchemaField
              ? _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm3: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            box: "",
                            label: "Field Name",
                            rules: _vm.fieldNameRule,
                            readonly: "",
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.Field,
                            callback: function ($$v) {
                              _vm.$set(field, "Field", $$v)
                            },
                            expression: "field.Field",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            box: "",
                            label: "Field Type",
                            items: _vm.fieldTypeNames,
                            rules: _vm.fieldTypeRule,
                            readonly: "",
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldType,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldType", $$v)
                            },
                            expression: "field.FieldType",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("metadata-input-field", {
                          attrs: {
                            box: "",
                            "input-type": field.FieldType,
                            ignoreValidate: true,
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldValue,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldValue", $$v)
                            },
                            expression: "field.FieldValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-flex", { attrs: { xs1: "" } }),
                  ],
                  1
                )
              : _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm3: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            box: "",
                            label: "Field Name",
                            rules: _vm.fieldNameRule,
                            autofocus: "",
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.Field,
                            callback: function ($$v) {
                              _vm.$set(field, "Field", $$v)
                            },
                            expression: "field.Field",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("v-select", {
                          attrs: {
                            box: "",
                            label: "Field Type",
                            items: _vm.fieldTypeNames,
                            rules: _vm.fieldTypeRule,
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldType,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldType", $$v)
                            },
                            expression: "field.FieldType",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm4: "", "pl-2": "", "pr-2": "" } },
                      [
                        _c("metadata-input-field", {
                          attrs: {
                            box: "",
                            "input-type": field.FieldType,
                            ignoreValidate: true,
                          },
                          on: { input: _vm.emitChange },
                          model: {
                            value: field.FieldValue,
                            callback: function ($$v) {
                              _vm.$set(field, "FieldValue", $$v)
                            },
                            expression: "field.FieldValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs1: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              fab: "",
                              icon: "",
                              small: "",
                              outline: "",
                              color: "red",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.removeField(i)
                              },
                            },
                          },
                          [_c("v-icon", [_vm._v("close")])],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        )
      }),
      _vm._v(" "),
      !_vm.hideAddButton
        ? _c(
            "v-btn",
            {
              attrs: {
                outline: "",
                color: "success",
                disabled: _vm.disableAddButton,
              },
              on: { click: _vm.addField },
            },
            [
              _c("v-icon", { attrs: { left: "" } }, [_vm._v("add")]),
              _vm._v(
                "\n    " + _vm._s(_vm.$t("Button.Add_Metadata_Field")) + "\n  "
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }